import { get as _get } from 'lodash'
import { defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue'
import { faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons'

import { Container, ContainerStatus, Item } from '@skinsoft/types'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { ItemCard } from '@skinsoft/ui'
import { LocationInput } from '@skinsoft/entity-ui/src/movement/component/movement-item-card/location-input'
import { Location } from '@skinsoft/ui/src/item-card/location'
import ContainerInput from './container-input'

require('./choose-item-modal.scss')

export const ChooseItemModal = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sItemCard: ItemCard,
        sLocationInput: LocationInput,
        sContainerInput: ContainerInput,
    },
    props: ['item'],
    template: require('./choose-item-modal.html'),
    data() {
        return {
            selectedLocation: null as unknown as Location,
            locationMode: true,
            selectedContainer: null as unknown as Container,
            setPermanentLocation: false,
            switchOnIcon: faToggleOn,
            switchOffIcon: faToggleOff,
            containerStatusesToSearch: [ContainerStatus.OPEN] as ContainerStatus[],
        }
    },
    methods: {
        open() {
            (this.$refs.modal as InstanceType<typeof BModal>).show()
        },
        onSelectedLocation(location) {
            this.selectedLocation = location
        },
        onSelectedContainer(container) {
            this.selectedContainer = container
        },
        confirmLocation() {
            if (this.locationMode) {
                this.$emit('location-validated', { location: this.selectedLocation, setPermanentLocation: this.setPermanentLocation })
            } else {
                this.$emit('container-validated', { container: this.selectedContainer })
            }
        },
    },
    computed: {
        selectedItemActualContainersIds() {
            return _get(this.item, 'conditioningItemSchema.actualContainer', [])
                // @ts-ignore
                ?.map(actualContainer => actualContainer.container)
                .filter(id => id != undefined)
                ?? []
        },
    },
})
